export default "__VITE_ASSET__CuoqpTn7__"